import styled from 'styled-components';
import colors from 'constants/colors';

export const PhoneNumberInputContainer = styled.div`

  width: 100%;
  position: relative;

  label {
    width: 100%;
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: ${colors.silver};
    letter-spacing: 1px;
    margin-bottom: 5px;
    white-space: nowrap;
    text-align: ${(props) => props.labelPosition === 'center'? 'center': 'left'};
  }

  :focus-visible {
    outline: none;
  }

  .iti {
    width: 100%;

    .iti__country-container {
      :focus-visible {
        outline: none;
      }

      button {
        :focus-visible, :focus {
          outline: none;
        }

        .iti__selected-country-primary {
          :focus-visible {
            outline: none;
          }

          :hover {
            background-color: ${({disabled})=>disabled? colors.dimGrey: colors.black5} !important;
          }
        }
      }

      .iti__dropdown-content {
        ${({disabled})=> disabled?  `display: none`: null};
        border: none;

        input {
          font-size: 14px;
          font-weight: 600;
          font-family: 'Titillium Web', sans-serif;
          color: ${colors.white};
          background-color: ${colors.black1};
          padding-left: 10px;
          letter-spacing: 0.5px;

          :focus-visible {
            outline: none;
            background-color: ${colors.black1};
          }
        }

        input::placeholder {
          font-weight: 300;
          font-style: italic;
          letter-spacing: 1px;
          color: ${colors.white};
        }

        ul {
          max-height: 290px;
          position: absolute;
          overflow-y: scroll;
          top: ${(props) => (props.title ? '60px' : '40px')};
          letter-spacing: 1px;
          width: 100%;
          border: solid ${colors.darkGrey};
          border-width: 0 1px 1px 1px; 
          z-index: 1100;

          li {
            width: 100%;
            height: 36px;
            line-height: 35px;
            font-size: 14px;
            font-weight: normal;
            padding-left: 10px;
            color: ${colors.white};
            background-color: ${colors.black2};
            overflow: hidden;

            .highlight {
              color: ${colors.white};
            }

            :hover {
              color: ${colors.lightBlue};
              border-left: 5px solid ${colors.lightBlue};
              background-color: ${colors.darkBlue};
              padding-left: 5px;

              .highlight {
                font-weight: bold;
                color: ${colors.lightBlue};
              }
            }
          }

          ::-webkit-scrollbar { 
            width: 0 !important; 
          }

          ::-moz-scrollbar {
            width: 0 !important; 
          }
        }
      }
    }

    input {
      font-size: ${(props) => (props.mainPage ? '14px' : '18px')};
      font-weight: 600;
      font-family: 'Titillium Web', sans-serif;
      width: 100%;
      box-sizing: border-box;
      height: 40px;
      border: 1px solid ${(props) => props.disabled? colors.silver: props.error? colors.red: (props.borderColor? props.borderColor : colors.darkGrey)};
      color: ${(props) => (props.disabled? colors.silver: colors.white)};
      padding-left: 10px;
      background-color: ${(props) => (props.disabled? colors.dimGrey: props.mainPage ? 'transparent' : colors.black2)};

      :focus-visible {
        outline: none;
        background-color: ${colors.black1};
      }
    }
  }


  .warning {
    width: ${(props) => (props.width? props.width: null)};
    height: 20px;
    position: absolute;
    color: ${colors.red};
    font-size: 14px;
    font-weight: 600;
    font-style: italic;
    white-space: nowrap; 
    text-overflow: ellipsis;
    overflow: hidden;
  }

  @media only screen and (min-width: 767px) and (max-width: 1200px) {

    span {
      font-size: 11px;
    }

    .PhoneInput {
      height: 46px;
    }
    
    .PhoneInputCountry {
      height: 46px;
    }

    input {
      height: 46px;
      font-size: ${(props) => (props.mainPage ? '15px' : '18px')};
    }
  }

  @media only screen and (max-width: 767px) {

    span {
      font-size: 11px;
    }

    .PhoneInput {
      height: 44px;
    }

    .PhoneInputCountry {
      height: 44px;
    }

    input {
      height: 44px;
      font-size: ${(props) => (props.mainPage ? '13px' : '18px')};
    }
  }

  ${(props) => props.additionalstyle};
`;